exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".guest {\n  box-sizing: border-box;\n  margin: 30px auto;\n  text-align: center;\n  padding: 0 25%; }\n  .guest .status {\n    padding: 15px;\n    color: #ffffff;\n    font-size: 24px; }\n  .guest .device-manager .devices {\n    background-color: #ffffff; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/guest/guest.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/components/guest/guest.scss
// module chunks = index